export class Stats {
    watchDomChanges = 0;
}